import { c as _c } from "react/compiler-runtime";
import HubspotForm from "@components/HubspotForm";
import { Mail, PhoneTelephone } from "@icon-park/svg";
import { Title } from "@justhome/react-ui";
import { ComponentSectionsContactUs } from "@lib/generated/graphql";
import { useApplicationTranslation } from "@lib/hooks/translations";
import { FC } from "react";
import ContactItem from "./ContactItem";
const ContactUs: FC<{
  data: ComponentSectionsContactUs;
}> = t0 => {
  const $ = _c(23);
  const {
    data
  } = t0;
  const {
    title,
    subTitle
  } = data;
  const {
    t
  } = useApplicationTranslation();
  let t1;
  if ($[0] !== title) {
    t1 = <Title className="text-d2">{title}</Title>;
    $[0] = title;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== subTitle) {
    t2 = <p className="text-body-1 text-neutral-575">{subTitle}</p>;
    $[2] = subTitle;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t) {
    t3 = t("opt_in_form_email_label");
    $[4] = t;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t3) {
    t4 = <ContactItem icon={Mail} label={t3} href="mailto:info@justhome.com" value="info@justhome.com" />;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t) {
    t5 = t("opt_in_form_phone_number_label");
    $[8] = t;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t5) {
    t6 = <ContactItem icon={PhoneTelephone} label={t5} href="tel:03091739560" value="030 9173 9560" />;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t1 || $[13] !== t2 || $[14] !== t4 || $[15] !== t6) {
    t7 = <div className="col-span-6 flex flex-col gap-m pb-m">{t1}{t2}{t4}{t6}</div>;
    $[12] = t1;
    $[13] = t2;
    $[14] = t4;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <div className="col-span-6"><HubspotForm id="c6f187c4-3778-4b07-a0c8-e1bd8e55f128" formId="c6f187c4-3778-4b07-a0c8-e1bd8e55f128" /></div>;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== t7) {
    t9 = <div className="flex flex-col m:grid grid-cols-12 m:px-3xl gap">{t7}{t8}</div>;
    $[18] = t7;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <div className="flex flex-col m:grid grid-cols-12 gap" />;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== t9) {
    t11 = <section className="flex flex-col pt-2xl px-s m:px-none">{t9}{t10}</section>;
    $[21] = t9;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  return t11;
};
export default ContactUs;